<template>
  <div class="topBar">
    <div class="menuStyle">
      <img src="@/assets/images/headerText.png" alt="" class="photo" />
      <span class="time-display">{{ currentTime }}</span>
      <!-- <el-menu
        :default-active="activeIndex"
        mode="horizontal"
        @select="handleSelect"
        class="leftMenu"
        background-color="#052d8d"
        text-color="#acf4ff"
        active-text-color="#acf4ff"
      >
        <top-bar :navMenus="leftRoute" />
      </el-menu> -->

      <div class="menuTitle">
        <img :src="logoPath" alt="" v-if="logoPath" />&ensp;
        <!-- <span class="title">南京理工&泰州学院数据驾驶舱</span> -->
        <span class="title">山西应用科技学院东区食堂</span>
      </div>
      <!-- <div class="rightMenu">
        <el-menu
          :default-active="activeIndex2"
          mode="horizontal"
          @select="handleSelect"
          background-color="#052d8d"
          text-color="#acf4ff"
          active-text-color="#acf4ff"
          class="myMenu"
        >
          <top-bar :navMenus="rightRoute" />
        </el-menu>
        <div class="pInfo">
          <span>你好，{{ userName }}</span>
          <el-dropdown trigger="click">
            <div class="avatar-wrapper">
              <img :src="require('@/assets/images/avatar.jpg')" class="user-avatar" />
              <i class="el-icon-caret-bottom" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <router-link to="/user/profile">
                <el-dropdown-item>个人中心</el-dropdown-item>
              </router-link>
              <el-dropdown-item divided @click.native="logout">
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import topBar from "./topBar";

export default {
  components: {
    Breadcrumb,
    topBar,
  },
  props: ["logoPath"],
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
      leftRoute: [],
      rightRoute: [],
      currentTime: "",
    };
  },
  watch: {},

  computed: {
    routeList() {
      return this.$store.state.permission.routeList;
    },
    userName() {
      return this.$store.state.user.name;
    },
  },
  created() {
    const length = this.routeList.length;
    const index = Math.round(length / 2);
    this.leftRoute = this.routeList.slice(0, index);
    this.rightRoute = this.routeList.slice(index, length);
    this.updateTime();
    this.timer = setInterval(this.updateTime, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    updateTime() {
      const now = new Date();
      this.currentTime = now.toLocaleString("zh-CN", {
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
    handleSelect(key, keyPath) {
      const str = keyPath.join("/");
      this.$router.push(`${str}`).catch(err => {
        // console.log(err);
      });
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    logout() {
      this.$confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch("LogOut").then(() => {
          location.href = "/index";
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.topBar {
  position: relative;
  ::v-deep .el-menu--horizontal > div > .el-submenu {
    float: left;
  }

  /* 一级菜单的样式,z-index:1解决hover1级菜单时不显示平行四边形*/
  ::v-deep .el-menu--horizontal > div > .el-menu-item {
    z-index: 1;
    font-size: 16px;
    float: left;
    height: 30px;
    line-height: 34px;
    // border-bottom: 2px solid transparent;
    color: #acf4ff;
    background-color: transparent !important;
  }

  /* 解决下图1 下拉三角图标 */
  ::v-deep .el-menu--horizontal > div > .el-submenu .el-submenu__icon-arrow {
    position: static;
    margin-left: 8px;
    margin-top: -3px;
  }
  /* 解决下图2 无下拉菜单时 不对齐问题 */
  ::v-deep .el-menu--horizontal > div > .el-submenu .el-submenu__title {
    font-size: 16px;
    height: 30px;
    line-height: 30px;
    // border-bottom: 2px solid transparent;
    color: #acf4ff;
  }
  /*拥有子菜单透明*/
  ::v-deep .el-submenu__title {
    z-index: 1;
    background-color: transparent !important;
  }
  /*整个菜单透明*/
  ::v-deep .el-menu.el-menu--horizontal {
    border-bottom: none;
    background-color: transparent !important;
  }
  /*选中菜单透明*/
  ::v-deep .el-submenu__title:hover {
    background-color: transparent !important;
  }
  /*选中时显示平行四边形*/
  ::v-deep .el-menu-item:hover::before,
  ::v-deep .leftMenu .el-submenu__title:hover::before,
  ::v-deep .myMenu .el-submenu__title:hover::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(rgba(45, 106, 251, 0.99), rgba(45, 106, 251, 0.3));
    transform: skewX(-45deg);
    z-index: -1;
  }
  ::v-deep .myMenu .el-submenu__title:hover::before,
  ::v-deep .myMenu .el-menu-item:hover::before {
    transform: skewX(45deg);
  }

  .menuStyle {
    display: flex;
    justify-content: center;
    // align-items: center;
    // background: var(--head-bgc);
    background: url("~@/assets/images/topBgc.png") no-repeat center/100% 100%;
    height: 83px;
    padding-top: 8px;
    .photo {
      position: absolute;
      left: 52px;
      top: 34px;
    }
    .time-display {
      position: absolute;
      right: 32px;
      top: 34px;
      font-size: 24px;
      color: #fff;
    }
    .menuTitle {
      width: 500px;
      color: #fff;
      text-align: center;
      font: bold 34px "方正中黑简体";
      img {
        width: 40px;
        vertical-align: middle;
      }
      .title {
        // display: inline-block;
        // line-height: vh(83);
      }
    }
    .leftMenu {
      flex: 1;
      display: flex;
      justify-content: space-between;
    }
    .rightMenu {
      flex: 1;
      display: flex;
      align-items: center;
      .myMenu {
        flex: 1;
        display: flex;
        justify-content: space-between;
      }
    }

    .pInfo {
      font-size: 14px;
      color: #e7e7e7;
      margin-right: 24px;
      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
        vertical-align: middle;
      }
    }
  }

  .navbar {
    // background: var(--overall-bgc);
    background: #052d8d;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    padding-left: 21px;
    vertical-align: middle;
    ::v-deep .app-breadcrumb.el-breadcrumb .no-redirect {
      // color: var(--title-color);
      color: #fff;
    }
    .breadcrumb-container {
      height: 42px;
      line-height: 42px;
    }
    .homeIcon {
      color: #fff;
      width: 16px;
      height: 13px;
    }
  }
}
</style>
